export const Types = {
  GET_DROPDOWN_MANUFACTURERS: "manufacturer/GET_DROPDOWN_MANUFACTURERS",
  GET_DROPDOWN_MANUFACTURERS_SUCCESS:
    "manufacturer/GET_DROPDOWN_MANUFACTURERS_SUCCESS",
  GET_DROPDOWN_MANUFACTURERS_ERROR:
    "manufacturer/GET_DROPDOWN_MANUFACTURERS_ERROR",
  SHOW_DRAWER_MANUFACTURER: "manufacturer/SHOW_DRAWER_MANUFACTURER",
  HIDE_DRAWER_MANUFACTURER: "manufacturer/HIDE_DRAWER_MANUFACTURER",
  SAVE_MANUFACTURER: "manufacturer/SAVE_MANUFACTURER",
  SAVE_MANUFACTURER_SUCCESS: "manufacturer/SAVE_MANUFACTURER_SUCCESS",
  SAVE_MANUFACTURER_ERROR: "manufacturer/SAVE_MANUFACTURER_ERROR",
  REFRESH_LIST_DROPDOWN: "manufacturer/REFRESH_LIST_DROPDOWN",
};

export const Creators = {
  getDropdownManufacturers: (groupId, farmId) => ({
    type: Types.GET_DROPDOWN_MANUFACTURERS,
    payload: { groupId, farmId },
  }),

  getDropdownManufacturersSuccess: (data) => ({
    type: Types.GET_DROPDOWN_MANUFACTURERS_SUCCESS,
    payload: { data },
  }),

  getDropdownManufacturersError: (error) => ({
    type: Types.GET_DROPDOWN_MANUFACTURERS_ERROR,
    payload: { error },
  }),

  showDrawer: () => ({
    type: Types.SHOW_DRAWER_MANUFACTURER,
    payload: {},
  }),

  hideDrawer: () => ({
    type: Types.HIDE_DRAWER_MANUFACTURER,
    payload: {},
  }),

  saveManufacturer: (groupId, farmId, manufacturer) => ({
    type: Types.SAVE_MANUFACTURER,
    payload: { groupId, farmId, manufacturer },
  }),

  saveManufacturerSuccess: (data) => ({
    type: Types.SAVE_MANUFACTURER_SUCCESS,
    payload: { data },
  }),

  saveManufacturerError: (error) => ({
    type: Types.SAVE_MANUFACTURER_ERROR,
    payload: { error },
  }),

  refreshDrowpDownList: (newManufacturer = null) => ({
    type: Types.REFRESH_LIST_DROPDOWN,
    payload: { newManufacturer },
  }),
};

const INITIAL_STATE = {
  listDropDown: [],
  isLoadingDropDown: false,
  isLoadingRequest: false,
  drawerVisible: false,
  shouldRefreshListDropDown: false,
  newManufacturer: null,
  error: null,
};

export default function manufacturer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_DROPDOWN_MANUFACTURERS:
      return { ...state, isLoadingDropDown: true };
    case Types.GET_DROPDOWN_MANUFACTURERS_SUCCESS:
      return {
        ...state,
        isLoadingDropDown: false,
        listDropDown: action.payload.data,
      };
    case Types.GET_DROPDOWN_MANUFACTURERS_ERROR:
      return {
        ...state,
        isLoadingDropDown: false,
        listDropDown: [],
        error: action.payload.error,
      };
    case Types.SHOW_DRAWER_MANUFACTURER:
      return { ...state, drawerVisible: true };
    case Types.HIDE_DRAWER_MANUFACTURER:
      return { ...state, drawerVisible: false };
    case Types.SAVE_MANUFACTURER:
      return { ...state, isLoadingRequest: true };
    case Types.SAVE_MANUFACTURER_SUCCESS:
      return {
        ...state,
        isLoadingRequest: false,
        drawerVisible: false,
      };
    case Types.SAVE_MANUFACTURER_ERROR:
      return {
        ...state,
        isLoadingRequest: false,
        error: action.payload.error,
      };
    case Types.REFRESH_LIST_DROPDOWN:
      return {
        ...state,
        shouldRefreshListDropDown: !state.shouldRefreshListDropDown,
        newManufacturer: action.payload.newManufacturer,
      };
    default:
      return state;
  }
}
